<template>
  <HeadlessButton v-bind="buttonProps" @click="handleClick">
    <slot />
  </HeadlessButton>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import HeadlessButton from '@/components/atoms/HeadlessButton.vue'

interface Props {
  variant?: 'primary' | 'secondary' | 'danger' | 'outline' | 'text'
  size?: 'small' | 'default' | 'large'
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  loading?: boolean
  loadingText?: string
  fullWidth?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
  size: 'default',
  type: 'button',
  disabled: false,
  loading: false,
  fullWidth: false,
})

const emit = defineEmits<{
  click: [event: MouseEvent]
}>()

const buttonProps = computed(() => {
  const baseProps = {
    variant: props.variant,
    size: props.size,
    type: props.type,
    disabled: props.disabled,
    loading: props.loading,
    fullWidth: props.fullWidth,
  }
  if (props.loadingText) {
    return { ...baseProps, loadingText: props.loadingText }
  }
  return baseProps
})

const handleClick = (event: MouseEvent): void => {
  emit('click', event)
}
</script>
